import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initApplicationEnvironmentConfiguration, environment2 } from '@environments/environment';

(async () => {
  await initApplicationEnvironmentConfiguration();

  const AppModule = await import('./app/app.module').then((m) => m.AppModule);

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
})();
